import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SearchModal } from '../../search-modal/search-modal';

@Component({
  selector: 'app-toolbar-search',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './toolbar-search.html',
  styleUrl: './toolbar-search.scss',
})
export class ToolbarSearch {
  private bottomSheet = inject(MatBottomSheet);

  openSearch(): void {
    this.bottomSheet.open(SearchModal, {
      panelClass: 'app-search-modal',
    });
  }
}
